import { AppStoreButtons } from './AppStoreButtons'

export function HeroSection() {
  return (
    <section className="relative section-x pt-8 sm:pt-12 pb-16 md:pb-24 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center kinetic-gradient">
      <div className="z-10 text-center lg:text-left">
        <h1 className="font-headline font-extrabold text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight mb-6 leading-[1.1] text-on-surface">
          Be ahead with your health and <span className="text-primary">fitness</span>
        </h1>
        <p className="text-on-surface-variant text-base sm:text-lg md:text-xl max-w-lg mx-auto lg:mx-0 mb-8 sm:mb-10 leading-relaxed">
          A training companion for building strength, mobility, and habits that stick —
          no matter how your day looks.
        </p>
        <AppStoreButtons centeredOnMobile />
      </div>

      <div className="relative flex justify-center lg:justify-end">
        <div className="relative w-full max-w-[260px] sm:max-w-[300px] lg:max-w-[320px] aspect-[0.46] rounded-[2rem] overflow-hidden shadow-2xl ring-4 sm:ring-8 ring-surface-container-low">
          <img
            alt="gymAhead home screen with workout list"
            className="w-full h-full object-cover"
            src="/1.png"
          />
        </div>
        <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-56 sm:w-80 h-56 sm:h-80 bg-primary/10 blur-[100px] rounded-full" />
      </div>
    </section>
  )
}
